/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-identification': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M13.75 6.875h2.5c.345 0 .625.28.625.625v1.25h-3.75V7.5c0-.345.28-.625.625-.625zM15 6.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm3.75 5h-7.5c-.69 0-1.25-.56-1.25-1.25V2.5c0-.69.56-1.25 1.25-1.25h7.5c.69 0 1.25.56 1.25 1.25V10a1.252 1.252 0 01-1.25 1.25zm-7.5-8.75V10h7.5V2.5h-7.5zM9.375 18.75h-1.25v-2.5a1.841 1.841 0 00-1.875-1.875h-2.5a1.841 1.841 0 00-1.875 1.875v2.5H.625v-2.5a3.094 3.094 0 013.125-3.125h2.5a3.094 3.094 0 013.125 3.125v2.5zM5 6.875a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zm0-1.25a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25z"/>'
  }
})
